import { render, staticRenderFns } from "./SelectRadioField.vue?vue&type=template&id=a5c1361e&scoped=true"
import script from "./SelectRadioField.vue?vue&type=script&lang=js"
export * from "./SelectRadioField.vue?vue&type=script&lang=js"
import style0 from "./SelectRadioField.vue?vue&type=style&index=0&id=a5c1361e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c1361e",
  null
  
)

export default component.exports